import React, { ReactElement } from 'react'
import SvgList from './SvgList'
interface DynamicSVGProps {
  SvgName: "Alert-Icon" | "Grid-Icon" | "Plus-Icon" |
  "Calender-Icon" | "Clipboard-Icon" | "Document-Icon" | "Menu-Icon" |
  "CheckMark-Icon" | "Info-Icon"|"Edit-Icon"|"Grip-Icon"|"Profile-Icon"|"Trash-Icon"
  className?: string,
  fill?: string
  stroke?: string,
  
}
export default function DynamicSVG({ SvgName, className ,fill,stroke}:DynamicSVGProps) {
  interface ISvgType{
    title?: string,
    fill?: string,
    stroke?: string
    strokeWidth?: number,
    d?: string,
    viewBox?:string,
    ExtraElement?:ReactElement
  }
  const svgType:ISvgType = GetSvgObject(SvgName)
  function GetSvgObject(svgName:string) {
    let svgObject = {}
    for (let i = 0; i < SvgList.length; i++) {
      if (SvgList[i].name == svgName) {
        svgObject = SvgList[i]
      }
    }
    return svgObject
  }

  return (
    <svg  className={className}
      xmlns="http://www.w3.org/2000/svg" viewBox={svgType.viewBox}>
      {svgType.ExtraElement}
      <path key={100} fill={fill || svgType.fill} stroke={stroke||svgType.stroke}
        strokeLinecap="round"
        strokeWidth={svgType.strokeWidth} d={svgType.d} />
    </svg>
  )
}
